import without from 'lodash/array/without';
import unique from 'lodash/array/unique';

export default ngModule => {

  /**
   * Multiselect checkbox view.
   **/
  ngModule.directive('multiSelect', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      replace: true,
      scope: {
        'model': '=ngModel',
        'choices': '=',
        // Min number of choices that have to be selected
        'minSelection': '=',
        // Max number of choices that have to be selected
        'maxSelection': '='
      },
      template: require("./multiselect.html"),
      link: (scope, element, attrs, ngModel) => {
        const validate = value => {
          if (scope.minSelection === scope.maxSelection) {
            ngModel.$setValidity('exactSelectionCount', scope.minSelection && value.length === scope.minSelection);
          } else {
            ngModel.$setValidity('minSelectionCount', scope.minSelection && value.length < scope.minSelection);
            ngModel.$setValidity('minSelectionCount', scope.maxSelection && value.length > scope.maxSelection);
          }
        }
        ngModel.$formatters.push(modelValue => {
          validate(modelValue);
        });

        element.data('validation-messages', {
          'minSelectionCount': 'Please select at least ' + scope.minSelection + ' items',
          'maxSelectionCount': 'Please select at most ' + scope.minSelection + ' items',
          'exactSelectionCount': 'Please select exactly ' + scope.minSelection + ' items'
        });

        ngModel.$parsers.push(viewValue => {
          validate(viewValue);
          return viewValue;
        });

        scope.onChange =  (service, checked) => {
          const currentSelection = ngModel.$modelValue;
          if (!checked) {
            ngModel.$setViewValue(unique(without(currentSelection, service)));
          } else {
            currentSelection.push(service);
            ngModel.$setViewValue(unique(currentSelection));
          }
        };
      }
    }
  });


}



// WEBPACK FOOTER //
// ./src/directives/multiselect.js